module.exports = __webpack_public_path__ + "static/media/00.9f8b1965.jpg";